import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import BreadcrumbItem from "react-bootstrap/BreadcrumbItem";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { Link } from "react-router-dom";

/* =========================================================
   🔹 DATA: E-RESOURCES & DATABASES
   ========================================================= */
const eResourcesList = [
  {
    name: "The New Yorker",
    logo: "/assets/img/researchtool/eresources/new-yorker-logo.png",
    coverage: "Since 2025",
    subjects:
      "Journalism, Commentary, Critics , Essays, Fiction, Satire, Cartoon and Poetry. ",
    url: "https://flipster.ebsco.com/c/mlobgq/details/4462325?backTo=%2Fc%2Fmlobgq",
    categories: ["DSSE", "AHSS", "Core"],
  },
  {
    name: "JSTOR",
    logo: "/assets/img/researchtool/eresources/jstor.png",
    coverage: "3039 E-Journals",
    subjects:
      "Arts & Sciences, Business, Ecology & Botany, General Science, Language & Literature, Music",
    url: "https://www.jstor.org/",
    categories: ["AHSS", "Core"],
  },
  {
    name: "JSTOR Sustainability Collection",
    logo: "/assets/img/researchtool/eresources/jstor-sustainability.png",
    coverage: "",
    subjects:
      "Environmental studies, business, economics, law, ecology, urban studies.",
    url: "https://www.jstor.org/sustainability/",
    categories: ["DSSE", "Core"],
  },
  {
    name: "IEEE: Robotics and Automation Magazine",
    logo: "/assets/img/researchtool/eresources/robotics-and-automation-magazine.png",
    subjects:
      "Aerospace, Components, Circuits, Devices and systems,Computing and Processing etc.",
    url: "https://ieeexplore.ieee.org/xpl/RecentIssue.jsp?punumber=100",
    categories: ["DSSE"],
  },
  {
    name: "IEEE: Power and Energy Magazine",
    logo: "/assets/img/researchtool/eresources/Power-and-Energy-Magazine.png",
    coverage: "2003 – 2022",
    subjects:
      "Power, Energy, industry applications, Geoscience, technological advancements.",
    url: "https://ieeexplore.ieee.org/xpl/RecentIssue.jsp?punumber=8014",
    categories: ["DSSE"],
  },
  // {
  //   name: "IEEE: Wireless Communications",
  //   logo: "/assets/img/researchtool/eresources/wireless-communications.png",
  //   coverage: "2002 – 2022",
  //   subjects:
  //     "Communication, Networking, Signal Processing, Broadcast Technologies.",
  //   url: "https://ieeexplore.ieee.org/xpl/RecentIssue.jsp?punumber=7742",
  //   categories: ["DSSE"],
  // },
  {
    name: "IEEE: Transactions on Circuits and Systems",
    logo: "/assets/img/researchtool/eresources/circuits-system.png",
    coverage: "2004 – 2022",
    subjects:
      "Circuits, Devices, Systems, MEMS, power electronics, control systems.",
    url: "https://ieeexplore.ieee.org/xpl/RecentIssue.jsp?punumber=8919",
    categories: ["DSSE"],
  },
  {
    name: "IEEE: Transactions on Games",
    logo: "/assets/img/researchtool/eresources/transaction-games.png",
    coverage: "2018 – 2022",
    subjects:
      "Scientific & engineering aspects of games, communication technologies.",
    url: "https://ieeexplore.ieee.org/xpl/RecentIssue.jsp?punumber=7782673",
    categories: ["DSSE"],
  },
  {
    name: "IEEE: control systems magazine",
    logo: "/assets/img/researchtool/eresources/control-systems-magazine.png",
    subjects:
      "Optimal Control, Power System, Control strategy.",
    url: "https://ieeexplore.ieee.org/xpl/mostRecentIssue.jsp?punumber=5488303",
    categories: ["DSSE"],
  },
   {
    name: "ACM Digital Library",
    logo: "/assets/img/researchtool/eresources/acm-digital-library.png",
    subjects:
      "computing theory, software engineering, artificial intelligence, data science, human-computer interaction, and emerging technologies.",
    url: "https://dl.acm.org/",
    categories: ["DSSE"],
  },
   {
    name: "SpringerLink",
    logo: "/assets/img/researchtool/eresources/springerlink.png",
    subjects:
      "scholarly resources across science, technology, medicine, social sciences, and humanities. Its content includes peer-reviewed journals, eBooks, reference works, protocols, and conference proceedings.",
    url: "https://link.springer.com/",
    categories: ["DSSE", "AHSS", "Core"],
  },
  {
    name: "IMF eLibrary",
    logo: "/assets/img/researchtool/eresources/imf-e-library.png",
    coverage: "11,000 Publications",
    subjects:
      "Economics, Finance, Development, IMF Publications & Statistics.",
    url: "https://www.elibrary.imf.org/",
    categories: ["AHSS", "Core"],
  },
  {
    name: "Bloomsbury Design Library",
    logo: "/assets/img/researchtool/eresources/bloomsburry-logo.png",
    coverage: "121 E-Books + Image Archives",
    subjects:
      "Design history, exhibitions, museum archives around the globe.",
    url: "https://www.bloomsburydesignlibrary.com/login?recentUrl=/home",
    categories: ["AHSS"],
  },
  {
    name: "Taylor & Francis Online",
    logo: "/assets/img/researchtool/eresources/taylor-logo.png",
    coverage: "2921 E-Journals",
    subjects:
      "Arts & Humanities, Media Studies, Sociology, Politics, Engineering.",
    url: "https://www.tandfonline.com/",
    categories: ["AHSS", "Core"],
  },
  {
    name: "Wiley Online Library",
    logo: "/assets/img/researchtool/eresources/wiley-logo.png",
    coverage: "1576 E-Journals",
    subjects:
      "Computing, Humanities, Environmental Science, Physical Sciences.",
    url: "https://onlinelibrary.wiley.com/action/showPublications",
    categories: ["Core"],
  },
];

/* =========================================================
   🔹 DATA: E-BOOKS
   ========================================================= */
const eBooksList = [
  {
    name: "EBSCO eBook IT Core Collection",
    logo: "/assets/img/researchtool/ebooks/ebsco-it.jpg",
    // coverage: "1576 E-Journals",
    subjects:
      "The EBSCO IT Core eBook Collection includes 4,573 eBooks from 100 leading publishers. It covers a wide range of IT disciplines, such as data science, artificial intelligence, cybersecurity, JavaScript, Python, programming, and more.",
    url: "https://research.ebsco.com/c/6hl3zr/search",
    categories: ["DSSE"],
  },
  {
    name: " EBSCO Engineering Core E Book Collection",
    logo: "/assets/img/researchtool/ebooks/ebsco-engineering.png",
    coverage: "Starting September 1, 2025",
    subjects:
      "Engineering disciplines including electrical, mechanical and civil.",
    url: "https://research.ebsco.com/c/6hl3zr?db=e230tww",
    categories: ["DSSE"],
  },
  {
    name: "JSTOR E-books",
    logo: "/assets/img/researchtool/eresources/jstor.png",
    // coverage: "1576 E-Journals",
    subjects:
      "A collection of 93000+  e-books on Arts & Humanities, Media Studies, Sociology, Politics, and Engineering by 100+ scholarly publishers including Columbia University Press, Cornell University Press, Indiana University Press, Rutgers University Press, NYU Press etc.",
    url: "https://www.jstor.org",
    categories: ["AHSS", "Core"],
  },
];

const EresourcesDatabases = () => {
const location = useLocation();

useEffect(() => {
  if (location.hash) {
    setTimeout(() => {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  }
}, [location]);
  return (
    <div className="Eresources">

      {/* =======================
         🔹 INNER BANNER
         ======================= */}
      <section className="inner-banner banner-align">
        <img
          className="img-fluid"
          src={process.env.PUBLIC_URL + "/assets/img/innerbanner/ahss.jpg"}
          alt=""
        />
      </section>

      {/* =======================
         🔹 PAGE CONTENT
         ======================= */}
      <section className="research-box-area">
        <Container>

          {/* ---------- Breadcrumb ---------- */}
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to="/">Home</Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to="/find-resources">Find Resources</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>E-Resources & Databases</BreadcrumbItem>
          </Breadcrumb>

          {/* =====================================================
             🔹 SECTION 1: E-RESOURCES & DATABASES
             ===================================================== */}
          <div className="information-content">
            <h2>E-Resources & Databases</h2>
          </div>

          <Tabs defaultActiveKey="DSSE" className="eresources-tabsWrap">
            {["DSSE", "AHSS", "Core"].map((tab) => (
              <Tab
                eventKey={tab}
                title={tab === "Core" ? "Core / Elective Courses" : tab}
                key={tab}
              >
                <Row className="ParentBorderBox">
                  {eResourcesList
                    .filter((item) => item.categories.includes(tab))
                    .map((item) => (
                      <Col lg={4} sm={6} className="bord" key={item.name}>
                        <div className="research-box">
                          <div className="logosWrapbox">
                            <img src={process.env.PUBLIC_URL + item.logo} alt={item.name} />
                          </div>
                          <div className="subjects">
                            {item.coverage && (
                              <p>
                                <b>Available Resources:</b> {item.coverage}
                              </p>
                            )}
                            <p><b>Subject Coverage:</b></p>
                            <p>{item.subjects}</p>
                          </div>
                          <a
                            className="link-btn"
                            target="_blank"
                            rel="noreferrer"
                            href={item.url}
                          >
                            <img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt="" />
                            {item.name}
                          </a>
                        </div>
                      </Col>
                    ))}
                </Row>
              </Tab>
            ))}
          </Tabs>

          {/* =====================================================
             🔹 SECTION 2: E-BOOKS
             ===================================================== */}
          <div className="information-content mt-5" id="ebooks">
            <h2>E-Books</h2>
          </div>

          <Tabs defaultActiveKey="DSSE" className="eresources-tabsWrap">
            {["DSSE", "AHSS", "Core"].map((tab) => (
              <Tab
                eventKey={tab}
                title={tab === "Core" ? "Core / Elective Courses" : tab}
                key={tab}
              >
                <Row className="ParentBorderBox">
                  {eBooksList
                    .filter((item) => item.categories.includes(tab))
                    .map((item) => (
                      <Col lg={4} sm={6} className="bord" key={item.name}>
                        <div className="research-box">
                          <div className="logosWrapbox">
                            <img src={process.env.PUBLIC_URL + item.logo} alt={item.name} />
                          </div>
                          
                          <div className="subjects">
                            <div className="name">
                              <p><b>Database Name:</b> {item.name}</p>
                            </div>
                            {item.coverage && (
                              <p>
                                <b>Trial Period:</b> {item.coverage}
                              </p>
                            )}
                            <p><b>Description:</b></p>
                            <p>{item.subjects}</p>
                          </div>
                          <a
                            className="link-btn"
                            target="_blank"
                            rel="noreferrer"
                            href={item.url}
                          >
                            <img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt="" />
                            {item.name}
                          </a>
                        </div>
                      </Col>
                    ))}
                </Row>
              </Tab>
            ))}
          </Tabs>

        </Container>
      </section>
    </div>
  );
};

export default EresourcesDatabases;
